import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';
// mock
import account from '../../../utils/account';
// components
import Logo from '../../../components/logo';
import NavSection from '../../../components/nav-section/NavSection';
//
import navConfig from './config';
import { filterNavConfig } from '../../../utils/roleAccess';
import { useWhatsappUnread, WhatsappUnreadBadge } from '../../../contexts/WhatsappUnreadContext';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  isDesktopNavOpen: PropTypes.bool,
  // Kept for DashboardLayout API compatibility; mobile uses MobileMoreSheet.
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ isDesktopNavOpen }) {
  const { count } = useWhatsappUnread();
  const filteredNavConfig = filterNavConfig(navConfig).map((item) =>
    item.path === '/whatsapp-inbox'
      ? { ...item, info: <WhatsappUnreadBadge count={count} /> }
      : item
  );

  const renderContent = (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={account.photoURL} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {account.displayName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection data={filteredNavConfig} />
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: isDesktopNavOpen ? NAV_WIDTH : 0 },
        display: { xs: 'none', lg: 'block' },
      }}
    >
      <Drawer
        open={isDesktopNavOpen}
        variant="persistent"
        PaperProps={{
          sx: {
            width: NAV_WIDTH,
            height: '100vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'background.default',
            borderRightStyle: 'dashed',
          },
        }}
      >
        {renderContent}
      </Drawer>
    </Box>
  );
}
